<template>
  <div style="background: #fff; padding: 20px">
    <el-form
      label-width="108px"
      :model="formData"
      ref="ruleForm"
      :rules="rules"
    >
      <el-form-item label="用户名" prop="username">
        <el-input
          type="text"
          style="width: 600px"
          placeholder="请输入用户名"
          v-model="formData.username"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="pass">
        <el-input
          type="password"
          style="width: 600px"
          v-model="formData.pass"
          autocomplete="off"
          placeholder="请输入密码"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="重复密码" prop="checkPass">
        <el-input
          type="password"
          style="width: 600px"
          v-model="formData.checkPass"
          autocomplete="off"
          placeholder="请输入密码"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input
          placeholder="请输入中国大陆手机号"
          v-model.number="formData.phone"
          style="width: 600px"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="验证码" prop="code">
        <el-input
          placeholder="请输入验证码"
          v-model.number="formData.code"
          clearable
          style="width: 150px; height: 34px"
          class="inputidecode"
        ></el-input>
        <el-button @click="getidecodeFun">{{ getidecodeData }}</el-button>
      </el-form-item>
      <el-form-item class="el-foot-bar fixed-footer-bar">
        <el-button type="primary" @click="submitForm('ruleForm')"
          >提交</el-button>
        <el-button @click="resetForm('ruleForm')">还原</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  name: "UpdateInfo",
  data() {
    var validatePassCheck = (rule, value, callback) => {
      if (value != this.formData.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      prephone:"",
      getidecodeData: "获取验证码",
      formData: {
        username: "",
        pass: "",
        checkPass: "",
        phone: "",
        code: "",
      },
      rules: {
        username: [
          {required: true,message: "请输入用户名", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        pass: [
          {  message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 50,
            message: "长度在 6 到 50 个字符",
            trigger: "blur",
          },
        ],
        checkPass: [
          // {  message: "请再次输入密码", trigger: "blur" },
          // {
          //   min: 6,
          //   max: 50,
          //   message: "长度在 6 到 50 个字符",
          //   trigger: "blur",
          // },
          { validator: validatePassCheck, trigger: "blur" },
        ],
        phone:[
          {required: true,message: "请输入手机号码", trigger: "blur" },
        ]
      },
    };
  },
  mounted(){
    this.getUser()
  },
  methods: {
    getUser() {
      let that = this;
      that.$api.get(
        "/api/index/userdata",{},
        (res) => {
          console.log(res.data)
          this.formData.username = res.data.name;
          this.formData.phone = res.data.phone;
          this.prephone  =  res.data.phone;
        },
        (r) => {
          // that.$message.error(r.msg);
        }
      );
    },
    submitForm(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.prephone!=this.formData.phone&&(this.formData.code<1000||this.formData.code>=9999)){//手机号码有变 并且 验证码不正确
            this.$message.warning("验证码错误")
            return
          }
          
// http://api.eaechina.net/api/index/updateUserInfo?name=ddsfs知识&phone=13271390735
        var formdata = {
          name:this.formData.username,
          phone:this.formData.phone
        }
        if(this.formData.code!=''){
          formdata.code = this.formData.code
        }
        if(this.formData.pass!=''){
          formdata.pass = this.formData.pass
        }
        that.$api.post("/api/index/updateUserInfo", formdata, (res) => {
            that.$message.success(res.msg)
            localStorage.setItem("_token",res.data.token);
            // that.$router.push({ name: "Login" });
            // that.getUser()
            setTimeout(()=>{
              location.reload();
            },1000)
        });

          




          //   if (that.formData.pics.length == 0) {
          //     that.$message.error("请上传图片");
          //     return false;
          //   }
          // that.$api.post("/api/cms/contentAdd", that.formData, (res) => {
          //   that.$message.success("保存成功");
          //   setTimeout(()=>{
          //       window.location.reload();
          //   },1000)
          // });
        } else {
          console.log("error submit!!");
          this.$message.error("输入错误")
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.getUser()
    },
    //获取验证码 点击事件
    getidecodeFun() {
      const that = this;
      if(this.getidecodeData != "获取验证码"){
        this.$message.warning("请稍后再试！")
        return
      }
      that.$api.post(
        "/api/index/phonecode",
        {
          phone: that.formData.phone,
        },
        (r) => {
          this.$message.success("发送成功");
          if (this.getidecodeData == "获取验证码") {
            this.getidecodeData = 59;
            var that = this;
            var timetime;
            timetime = setInterval(function () {
              that.getidecodeData -= 1;
              if (that.getidecodeData <= 0) {
                clearInterval(timetime);
              }
            }, 1000);
          }
        },
        (r) => {
          that.$message.error(r.msg);
        }
      );
    },
  },
  watch: {
    getidecodeData(newval, oldval) {
      if (newval == 0) {
        this.getidecodeData = "获取验证码";
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// UpdataInfo.vue?618cc56e